import { render, staticRenderFns } from "./PhoneNumberInputComponent.vue?vue&type=template&id=961d6ebc"
import script from "./PhoneNumberInputComponent.vue?vue&type=script&lang=js"
export * from "./PhoneNumberInputComponent.vue?vue&type=script&lang=js"
import style0 from "./PhoneNumberInputComponent.vue?vue&type=style&index=0&id=961d6ebc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
